module.exports = __webpack_public_path__ + "img/intro_2.c6f42c1b.png";